import home from 'Site/home';
import './home.scss';

home();
